import { render } from "./About.vue?vue&type=template&id=aaad2282"
const script = {}
script.render = render

export default script